import { render, staticRenderFns } from "./ContratoApostilamentos.vue?vue&type=template&id=6bbc4dfe&"
import script from "./ContratoApostilamentos.vue?vue&type=script&lang=js&"
export * from "./ContratoApostilamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports